import { css, html, LitElement, PropertyValues, svg } from 'lit';
import { customElement, query, state } from 'lit/decorators';
import {unsafeHTML} from 'lit/directives/unsafe-html';

import { classMap } from 'lit/directives/class-map';
import { menuStyles, scrollbarStyles, waitStyles } from '../core/styles';
import proj4 from 'proj4';
import { IAlertOptions, IStorage, IUserInterface } from './user-interface';
import { AppStorage } from '../shared/storage';
import { commonStyles, desktopStyles, formStyles, textStyles } from '../core/styles-desktop';
import { SilverMap } from './components/map/silver-map';
import { IParameter } from './services';
import { IToolEvent, SilverTools } from './components/tools/silver-tools';
import { KelydraOverlay } from '../core/components/overlay/kelydra-overlay';
import { ref } from 'lit/directives/ref';
import { SilverBrowserMapLayerControl } from './components/map/sb-carto-layer-control';
import { KelydraUtils } from '../core/utils';
import { ITreeItem, KelydraTree, TreeSelectElementEvent } from '../core/components/tree/kelydra-tree';
import { KelydraIcon } from '../core/components/icon/kelydra-icon';

const TYPE_LAYER_DOCUMENT = "43ff634d-fde7-4a26-a701-6f8b41bd9a36";
const TYPE_LAYER_DOCUMENT_TREE = "8bcb197e-5129-43ed-bee6-5b38095e97bf";

@customElement('sb-prg')
export class SilverPrgApplication extends LitElement {


  public static Version = "0.0";
  public static Build = "0";


  static styles = [
    commonStyles,
    desktopStyles,
    waitStyles,
    scrollbarStyles,
    formStyles,
    textStyles,
    menuStyles,
    css`

    silver-map {
      position:absolute;
      inset:0px;
    }

    silver-tools {
      position:absolute;
      top: 0px;
      width: 100%;
    }

    .tool-overlay {
      --move-handle-right:32px;
    }

    .tool-panel {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .tool-panel-title {
      display: flex;
      align-items:center;
      background:gray;
      height: 32px;
    }

    .tool-panel-title-icon {
      position: absolute;
      top:-24px;
    }

    .tool-panel-title-caption {
      padding-left: 40px;
      color: white;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      flex: 1;
    }

    .tool-panel-title-close {
      height: 26px;
    }

    .tool-panel-title-close img {
      width: 26px;
      cursor: pointer;
      margin-right:4px;
      filter: invert(100%);      
    }


    .tool-panel-content {
      flex: 1;
      overflow-y: auto;
      position: relative;
    }


    .tool-panel-filter {
      margin-top: 4px;
      display:flex;
      justify-items: center;
    }

    .tool-panel-filter k-component-filter {
      flex: 1;
    }

    .tool-panel-filter .filter-button {
      width: 32px;
      height: 32px;
      cursor: pointer;
    }

    #panel-measure table .label {
      width:80px;
    }

    #panel-measure table .value {
      width:100px;
      text-align:right;
      font-size:14px;
      font-weight:bold;
    }


    #panel-document-link .tool-panel-content {
      overflow:hidden;
    }

    #panel-document-link .tool-panel-content iframe {
      width: 100%;
      height: 100%;
    }

    #panel-document-tree .tool-panel-content k-splitter {
      position: absolute;
      inset:0px;
    }

    #panel-document-tree .tool-panel-content k-splitter .tree {
      position: absolute;
      inset: 0px;
      display: flex;
      flex-direction: column;
    }

    #panel-document-tree .tool-panel-content k-splitter .tree .tree-tools {
      display:flex;
      margin:2px;

      button {
        flex: 1;
        background: transparent;
        border: 1px solid gray;
        padding: 6px;
        cursor:pointer;
        margin-left:2px;

        &.selected {
          font-weight: bold;
          background: #f0f0f0;
        }
      }
    }

    #panel-document-tree .tool-panel-content k-splitter .tree .tree-container {
      flex: 1;
      position:relative;
      
      .documents-all, .documents-selected {
        position: absolute;
        inset:0px;
        visibility: hidden;
        overflow-y: auto;

        &.selected {
          visibility: visible;
        }
      }

      .document-selected {
        padding: 4px;
        overflow: hidden;

        &.selected {
          background: var(--selection-background, blue);
          color: white;
        }
      }
    }


    #panel-document-tree .tool-panel-content k-splitter .articolo {
      position: absolute;
      inset: 0px;
      display: flex;
      flex-direction: column;
    }

    #panel-document-tree .tool-panel-content k-splitter .articolo .articolo-path {
      padding-left: 12px;
    }

    #panel-document-tree .tool-panel-content k-splitter .articolo .articolo-paths > .articolo-path {
      padding-left: 2px;
    }


    #panel-document-tree .tool-panel-content k-splitter .articolo .articolo-caption {
      font-weight: bold;
      padding-bottom:6px;
    }

    #panel-document-tree .tool-panel-content k-splitter .articolo .articolo-content {
      flex: 1;
      overflow-y:auto;
    }


    .tool-panel-buttons {
      padding: 6px;
      text-align: center;
    }

    .tool-panel-buttons button {
      padding: 4px 8px;
      width: 120px;
      background: lightgray
    }

    #panel-legend {
      --overlay-background: #f0f0f0c0;
    }

    .panel-info-main {
      display: flex;
      align-items: center;
    }

    .panel-info-logo img {
       width: 128px; 
       padding: 16px 32px;
       filter: drop-shadow(rgba(0, 0, 0, 0.5) 5px 5px 2px);
    } 

    .panel-info-title {
      text-align: center;
      padding-right: 16px;
      flex: 1;
    }

    .panel-info-customer {
      font-family: 'Times New Roman', Times, serif;
      font-size: 24px;
      font-weight: bold;
      padding-bottom: 6px;
    }

    .panel-info-product-title {
      font-size: 16px;
    }

    .panel-info-product-sub {
      margin-top: 8px;
      font-size: 16px;
    }


    .panel-info-sub {
      display: flex;
      align-items: center;
    }

    .panel-info-sub img {
      width: 160px;
      padding: 4px 8px;
    }

    .panel-info-version {
      text-align: center;
      padding: 0 8px;
      font-size:14px;
      flex: 1;
    }

    .panel-info-engine {
      text-align: center;
      font-size:12px;
    }


    .border {
      border: 1px solid lavender;
      margin: 2px;
      padding: 4px;
    }


 `];


  static instance:SilverPrgApplication;



  urlRootApp:string;
  urlRootSilverBrowser:string;

  crs:string;

  context:IAppContext;

  parameters:{[name:string]:any};


  @query('silver-map')
  map:SilverMap;

  @query('silver-tools')
  tools:SilverTools;

  @query('#panel-measure')
  panelMeasure:KelydraOverlay

  @query('k-tree')
  protected treeElement:KelydraTree;


  normaTree:INormaTreeData;
  documentsCache:{[uid:string]:INormaData} = {};
  treeLookup:{[uuid:string]:ITreeItem};

  @state()
  tree:ITreeItem;

  @state()
  selection:ITreeItem[] = [];
  selectionSelected:ITreeItem;

  @state()
  documentsShow:'all' | 'selected' = 'all';

  @state()
  documentDataEntity:INormaData;




  ui:IUserInterface;

  protected _ready:Promise<IAppContext>
  protected readyResolve : (value:IAppContext) => void; 

  protected _storage:IStorage;



  constructor() {
    super();
    console.log("SilverPrg started");
    this._storage = new AppStorage();
    SilverPrgApplication.instance = this;
    this._ready = new Promise(resolve => {
      this.readyResolve = resolve;
    })
    this.ui = new UserInterface(this._ready, this);
  }
  
  
  get storage():IStorage {
    return this._storage;
  }

  get ready():Promise<IAppContext> {
    return this._ready;
  }




  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    SilverPrgApplication.Version = this.dataset.releaseVersion;
    SilverPrgApplication.Build = this.dataset.releaseBuild;
    this.initApp();
  }



  protected async initApp() {

    let urlRoot = window.document.location.toString().substring(0, window.document.location.toString().indexOf("/",10));
    let appContext = window.document.location.toString().substring(urlRoot.length, window.document.location.toString().indexOf("/", urlRoot.length + 2));

    this.urlRootApp = urlRoot + appContext;
    this.urlRootSilverBrowser = urlRoot + "/SilverBrowser";

    KelydraIcon.registerSvgTemplate('square-minus', svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M 5 5 L 5 27 L 27 27 L 27 5 Z M 7 7 L 25 7 L 25 25 L 7 25 Z M 11 15 L 11 17 L 21 17 L 21 15 Z"/></svg>`);
    KelydraIcon.registerSvgTemplate('square-plus', svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M 5 5 L 5 27 L 27 27 L 27 5 Z M 7 7 L 25 7 L 25 25 L 7 25 Z M 15 11 L 15 15 L 11 15 L 11 17 L 15 17 L 15 21 L 17 21 L 17 17 L 21 17 L 21 15 L 17 15 L 17 11 Z"/></svg>`);


    proj4.defs("EPSG:3003","+proj=tmerc +lat_0=0 +lon_0=9  +k=0.999600 +x_0=1500000 +y_0=0 +ellps=intl +units=m +no_defs");
    proj4.defs("EPSG:3004","+proj=tmerc +lat_0=0 +lon_0=15 +k=0.999600 +x_0=2520000 +y_0=0 +ellps=intl +units=m +no_defs +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68");

    //Carica il contesto
    this.context = await this.remoteCall("silverbrowser://module/publisher/core/context");

    this.parameters = this.context.parameters.reduce((buffer:any, p) => {buffer[p.name] = p.value; return buffer}, {});

    this.crs = this.parameters['Map.CRS'];
    let mapBackground = this.parameters['Map.Background'];


    setTimeout(()=> {
      this.map.initMap(this.urlRootSilverBrowser, this.context.servicesInfo, this.crs, {background:mapBackground});
      this.requestUpdate();
    })

    setTimeout(()=> {
      if (Array.from(KelydraUtils.getQueryParameters()).length == 0 || KelydraUtils.getQueryParameter('popup') == 'true') {
        let panel = this.shadowRoot.querySelector('#panel-help') as KelydraOverlay;
        panel.show();
        setTimeout(() => {
          panel.hide();
        }, 3000);
      }
    }, 500)
  }

  protected doSelectTool(e:CustomEvent<IToolEvent>) {
    let panel:KelydraOverlay
    if (e.detail?.tool) {
      panel = this.shadowRoot.querySelector('#panel-' + e.detail?.tool);
    }

    switch(e.detail?.tool) {
      case 'identify':
        if (this.panelMeasure.visible) {
          this.panelMeasure.hide();
        }
        this.map.doStartIdentify();
        break;
      case 'legend':
      case 'search':
      case 'help':
        panel.show();
        break;
      case 'measure':
        panel.show();
        this.map.doStartMeasure((distance:number, perimeter:number, area:number) => {
          this.shadowRoot.getElementById('measure-dialog-length-a').innerHTML = distance.toLocaleString('it-IT', {minimumFractionDigits:2, maximumFractionDigits:2});
          this.shadowRoot.getElementById('measure-dialog-length-b').innerHTML = (distance/1000).toLocaleString('it-IT', {minimumFractionDigits:2, maximumFractionDigits:2});
    
          this.shadowRoot.getElementById('measure-dialog-perimeter-a').innerHTML = perimeter.toLocaleString('it-IT', {minimumFractionDigits:2, maximumFractionDigits:2});
          this.shadowRoot.getElementById('measure-dialog-perimeter-b').innerHTML = (perimeter/1000).toLocaleString('it-IT', {minimumFractionDigits:2, maximumFractionDigits:2});
          
          this.shadowRoot.getElementById('measure-dialog-area-a').innerHTML = area.toLocaleString('it-IT', {minimumFractionDigits:2, maximumFractionDigits:2});
          this.shadowRoot.getElementById('measure-dialog-area-b').innerHTML = (area/1000000).toLocaleString('it-IT', {minimumFractionDigits:2, maximumFractionDigits:2});
        });
        break;
      case 'print':
        (this.shadowRoot.querySelector("input[name='print-scale']") as HTMLInputElement).value = this.map.scale;
        panel.show();
        break;
      case 'documents':
        this.doDocuments();
        break;
    }
  }

  protected async doSearch() {
    let sez = (this.shadowRoot.querySelector("input[name='search-sez']") as HTMLInputElement).value;
    let foglio = (this.shadowRoot.querySelector("input[name='search-foglio']") as HTMLInputElement).value;
    let numero = (this.shadowRoot.querySelector("input[name='search-numero']") as HTMLInputElement).value;
    let reset = (this.shadowRoot.querySelector("input[name='search-reset']") as HTMLInputElement).checked;

    if (reset) {
      this.map.acetateClearAll();
    }

    //Cerco la particella 
    let searchResult:ICartoSearchResult = await this.remoteCall("silverbrowser://module/publisher/carto/search?type=particella&SEZ="+encodeURIComponent(sez)+"&FOGLIO="+encodeURIComponent(foglio)+"&NUMERO="+encodeURIComponent(numero));
    if (searchResult.wkt) {
      //La mostro nella mappa
      this.map.acetateAddWkt(searchResult.wkt, searchResult.entityId, true);
    }
  }


  protected doSearchClean() {
    (this.shadowRoot.querySelector("input[name='search-sez']") as HTMLInputElement).value = '';
    (this.shadowRoot.querySelector("input[name='search-foglio']") as HTMLInputElement).value = '';
    (this.shadowRoot.querySelector("input[name='search-numero']") as HTMLInputElement).value = '';
    (this.shadowRoot.querySelector("input[name='search-reset']") as HTMLInputElement).checked = true;

    //Pulisco la selezione precedente
    this.map.acetateClearAll();
  }

  protected async doDocuments() {
    switch (this.context.ntaReferenceType) {
      case 'download':
        window.open(this.urlRootSilverBrowser + "/services/rest/module/publisher/core/download/" + this.context.ntaReference, "NTA");
        break;
      case 'link':
        window.open(this.context.ntaReference, "NTA");
        break;
      case 'popup':
        let panelLink:KelydraOverlay = this.shadowRoot.querySelector('#panel-document-link');
        panelLink.show();
        break;
      case 'tree':
        this.doDocumentTree();
        break;
      }
  }

  public async doDocumentTree(documentIds?:string | string[]) {
    //Se necessario carica l'albero
    if (!this.normaTree) {
      let normeTree:INormaTreeData[] = await this.remoteCall("silverbrowser://core/dataEntity/data/find?type="+TYPE_LAYER_DOCUMENT_TREE,{TR_NAME:this.context.ntaReference});  

      if (normeTree.length) {
        this.normaTree = normeTree[0];
        this.parseNormaTree();
      }
    }
    let panel:KelydraOverlay = this.shadowRoot.querySelector('#panel-document-tree');
    panel.show();

    setTimeout(()=> {
      //TODO Se presente evidenzia il documento selezionato
      if (documentIds) {
        this.selection = [];
        this.selectionSelected = undefined;

        this.documentsShow = 'all';
        if (typeof documentIds == 'string') {
          let item = this.treeLookup[documentIds];
          this.treeElement.select(item, true);
        } else {
          this.documentsShow = 'selected';
          for (const documentId of documentIds) {
            let item = this.treeLookup[documentId];
            this.selection.push(item);
          }
          if (this.selection.length) {
            this.onSelectionSelect(this.selection[0]);
          }
        }
        console.log("Documento:" + documentIds);
      }
    });

  }

  protected parseNormaTree() {
    let parseElement = (node:IJsonTree, parent:ITreeItem = null):ITreeItem => {
        let result:ITreeItem = {
          data:node.uuid,
          caption:node.caption,
          children:[],
          parent:parent,
        }

        for (let child of (node.children || [])) {
          result.children.push(parseElement(child, result));
        }

        return result;
    };

    const tree = parseElement(JSON.parse(this.normaTree.TR_TREE || "{}"));
    if (!tree.caption) {
      tree.caption = this.normaTree.TR_CAPTION;
    }
    this.tree = tree;

    let buildLookup = (item:ITreeItem) => {
      this.treeLookup[item.data] = item;
      for (const child of item.children) {
        buildLookup(child);
      }
    }
    this.treeLookup = {};
    buildLookup(tree);

  }

  protected async onNormeTreeSelect(e:CustomEvent<TreeSelectElementEvent>) {
    console.log('select element')

    const item:ITreeItem = e.detail.item;

    //await this.clearNorma();
    //this.normaTreeItem = item;
    //this.treeElement.selectedItem = item;
    //this.treeElement.requestUpdate();    

    if (item) {
      if (!this.documentsCache[item.data]) {
        try {
          let dataEntity:IDataEntityResult = await this.remoteCall("silverbrowser://core/dataEntity/data/get?id=" + encodeURIComponent(item.data));
          this.documentsCache[item.data] = dataEntity.entity;
        } catch (error) {
//          this.treeElement.requestUpdate();
        }
      }

      if (this.documentsCache[item.data]) {
        this.documentDataEntity = this.documentsCache[item.data];
      }

     }
  }

  protected onSelectionSelect(item:ITreeItem) {
    this.selectionSelected = item;
    this.treeElement.select(item, true);
  }

    protected async showDocument(uuid:string) {
      if (!this.documentsCache[uuid]) {
        try {
          let dataEntity:IDataEntityResult = await this.remoteCall("silverbrowser://core/dataEntity/data/get?id=" + encodeURIComponent(uuid));
          this.documentsCache[uuid] = dataEntity.entity;
        } catch (error) {
//          this.treeElement.requestUpdate();
        }
      }

      if (this.documentsCache[uuid]) {
        this.documentDataEntity = this.documentsCache[uuid];
      }
    }



  protected async doPrint() {
    let title = (this.shadowRoot.querySelector("input[name='print-title']") as HTMLInputElement).value;
    let subtitle = (this.shadowRoot.querySelector("input[name='print-subtitle']") as HTMLInputElement).value;
    let scale = (this.shadowRoot.querySelector("input[name='print-scale']") as HTMLInputElement).value;
    let format = (this.shadowRoot.querySelector("select[name='print-format']") as HTMLSelectElement).value;
    let selection = (this.shadowRoot.querySelector("input[name='print-selection']") as HTMLInputElement).checked;
    let entitySelected : string = "";
    if (selection) {
      entitySelected = this.map.acetates.map(acetate => acetate.data).join(",");
    }

    var bounds = this.map.map.mapBounds;
    var queryString = "title="+title+"&subtitle="+subtitle+"&scale="+scale+"&exportFormat="+format +
        "&bbox="+bounds.xMin+","+bounds.yMin+","+bounds.xMax+","+bounds.yMax+
        "&" + this.map.layerMain.getQueryStringVisibility() + "&" + this.map.layerMain.getQueryStringExtra();

    if (selection) {
      queryString += "&selection=1&entitySelected="+encodeURIComponent(entitySelected);
    }    

    let result:ICartoExportResult = await this.remoteCall("silverbrowser://module/publisher/carto/map/export?"+queryString);
    window.open(this.urlRootSilverBrowser + "/" + result.url, "Report");

  }

  onLayersFilter(txt:string) {
    this.renderRoot.querySelectorAll('sb-map-layer-control').forEach(element => {(element as SilverBrowserMapLayerControl).filter = txt});
  }

  doLayersAction(action:string, refreshCarto:boolean = true) {
    this.renderRoot.querySelectorAll('sb-map-layer-control').forEach(element => {(element as SilverBrowserMapLayerControl).layersAction(<any>action)});
    if (refreshCarto) {
      this.renderRoot.querySelectorAll('sb-map-layer-control').forEach(element => {(element as SilverBrowserMapLayerControl).layersUpdate()});
    }
  }



  remoteCall<T>(path:string, data:any = null, options:{contentType?:'json'|'form', responseType?:'json'|'text', showError?:boolean, showWait?:boolean} = {}):Promise<T> {
    options = Object.assign({contentType:'form', responseType:'json', showError:true, showWait:true}, options);

    if (options.showWait) {
      this.ui.showWait();
    }


    let init: RequestInit = {
      credentials: "include"
    };

    if (data) {
      if (options && options.contentType == "json") {
        init.headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        init.body = JSON.stringify(data)
      } else {
        const body = new URLSearchParams();

        if (data instanceof FormData) {
          let formData = data as FormData;
          for (var pair of formData.entries()) {
            body.append(pair[0], pair[1].toString());
          }
        } else {
          for (const key in data) {
            const value = data[key];
            if (value !== null && typeof value !== "undefined") {
              body.append(key, value);
            }
          }
        }


        init.body = body;
      }
      init.method = "post";
    }

    let onError = (error:any) => {
      let message = String(error);
      let renderAsHtml:boolean = message.toLowerCase().startsWith('<html>');
      this.ui.alert({title:'Errore', message:String(error), messageType:'error', renderAsHtml:renderAsHtml, buttons:[{label:'OK'}]});
    }

    
    let [virtualProtocol, virtualPath] = path.split("://");
    let url;
    switch (virtualProtocol) {
      case 'silverbrowser' : 
        url = this.urlRootSilverBrowser + "/services/rest/" + virtualPath; break;
      case 'cloud' : 
        url = this.urlRootApp + "/services/rest/" + virtualPath; break;
      default:
        url = path;
    }

    return fetch(url, init).then(async response => {
      try {
        if (response.status != 200) {
          if (response.status == 401) {
            throw "Sessione scaduta!<br>Effettuare un nuovo login";
          }
          throw await response.text();
        }
        if (options.responseType == "text") {
          return await response.text();
        }
        let serviceResult:any = await response.json();
        if (serviceResult.hasOwnProperty('type')) {
          let type = serviceResult['type'];
          if (type != "ERROR") {
            let result = serviceResult['result'];
            if (serviceResult['resultTypeName']) {
              result['_typeName'] = serviceResult['resultTypeName'];
            }
            return result;
          } else {
            const error = serviceResult['message'];
            if (options.showError) {
              onError(error);
            }
            throw error;
          }
  
        } else {
          return serviceResult;
        }
      } finally {
        if (options.showWait) {
          this.ui.hideWait();
        }
      }

    }).catch(error => {
      if (options.showWait) {
        this.ui.hideWait();
      }
      if (options.showError) {
        onError(error);
      }
      throw error;
    });
  }

  onPanelClose(name:string) {
    switch (name) {
      case 'measure':
        this.tools.doSelectTool('identify');
        break;
    }
  }

  onMapReady() {
    this.tools.doSelectTool('identify');
    this.processParameters();
  }

  async processParameters() {
    var selectWkt = KelydraUtils.getQueryParameter("wkt");
    var selectPoint = KelydraUtils.getQueryParameter("point");
    var selectParticella = KelydraUtils.getQueryParameter("particella");
    if (selectPoint || selectParticella ||selectWkt) {
        if (selectPoint) {
          selectWkt = 'POINT (' + selectPoint.replace(',',' ') + ')';
        }

        if (selectParticella) {
            var token:string[] = selectParticella.split(',');
            let tokenIdx = 0;
            let sez = token.length > 2 ? token[tokenIdx++] : '';
            let foglio = token[tokenIdx++];
            let numero = token[tokenIdx++];
            let searchResult:ICartoSearchResult = await this.remoteCall("silverbrowser://module/publisher/carto/search?type=particella&SEZ="+encodeURIComponent(sez)+"&FOGLIO="+encodeURIComponent(foglio)+"&NUMERO="+encodeURIComponent(numero));
            if (searchResult.wkt) {
              selectWkt = searchResult.wkt;
            }
        }

        if (selectWkt) {
          setTimeout(()=> {
            this.map.acetateAddWkt(selectWkt, selectWkt, true);
          },500)
        }


    }

  }

  showWait() {
    this.shadowRoot.getElementById('wait').classList.remove("hidden");
  }

  hideWait() {
    this.shadowRoot.getElementById('wait').classList.add("hidden")
  }

  renderPanelLegend() {
    if (!this.map || !this.map?.map) {
      return;
    }

    const map = this.map.map;
    const legendLayers = map.layers;

    let overlayRef:KelydraOverlay;

    return html`
        <k-overlay id="panel-legend" class="tool-overlay" anchor="window" moveable="moveable" resizable="resizable"  autoclose="none" ${ref((value:any) => {overlayRef = value})} 
                   position="custom" initialWidth="400px" initialHeight="400px" initialLeft="60px" initialTop="120px">
          <div class="tool-panel">
            <div class="tool-panel-title">
              <div class="tool-panel-title-icon"><img src="resources/image/legend.png"></div>
              <div class="tool-panel-title-caption">Legenda</div>
              <div class="tool-panel-title-close"><img src="resources/svg/close.svg" @click=${() => overlayRef.hide()}></div>
            </div>
            <div class="tool-panel-filter">
              <k-component-filter class="flex-fill" @filter=${(e:any) => this.onLayersFilter(e.detail.filter)} placeholder="Cerca in legenda" ></k-component-filter>                 
                  <div class="filter-button">
                    <div class="filter-button-icon"><img src="resources/svg/more.svg" id="extra-layers" data-overlay-id="menu-layers" @click=${KelydraOverlay.toggleAnchored}></div>
                    <k-overlay id="menu-layers" position="bottom" anchor="extra-layers" autoclose="autoclose" align="end" >
                      <div class="popup">
                        <div class="menu-item" @click=${() => this.doLayersAction('visibility.show')}>Accendi tutti</div>
                        <div class="menu-item" @click=${() => this.doLayersAction('visibility.hide')}>Spegni tutti</div>
                        <div class="menu-item" @click=${() => this.doLayersAction('visibility.reset')}>Visibilità di default</div>
                        <div class="menu-item separator"  @click=${() => this.doLayersAction('tree.open', false)}>Espandi tutti</div>
                        <div class="menu-item"  @click=${() => this.doLayersAction('tree.close', false)}>Collassa tutti</div>
                      </div>
                    </k-overlay>           
                  </div>                       
            </div>
            <div class="tool-panel-content">
              ${legendLayers?.map(layer => {
                return html`
                  <sb-map-layer-control .map=${map} layerName=${layer.id} .collapsed=${true}>
                  </sb-map-layer-control>
                `;
              })}
            </div>
          </div>
        </k-overlay>
    `
  }

  renderPanelSearch() {
    let overlayRef:KelydraOverlay;

    return html`
        <k-overlay id="panel-search" class="tool-overlay" anchor="window" moveable="moveable"  autoclose="none" ${ref((value:any) => {overlayRef = value})} 
                    position="custom" initialLeft="80px" initialTop="160px">
          <div class="tool-panel">
            <div class="tool-panel-title">
              <div class="tool-panel-title-icon"><img src="resources/image/search.png"></div>
              <div class="tool-panel-title-caption">Ricerca</div>
              <div class="tool-panel-title-close"><img src="resources/svg/close.svg" @click=${() => overlayRef.hide()}></div>
            </div>
            <div class="tool-panel-content">
              <div class="form-form">
                <div class="form-row">
                  <div class="form-field ${classMap({hidden:this.context?.sezioni.length <= 1})}">
                    <label>Sez</label>
                    <input name="search-sez">
                  </div>
                  <div class="form-field">
                    <label>Foglio</label>
                    <input name="search-foglio">
                  </div>
                  <div class="form-field">
                    <label>Numero</label>
                    <input name="search-numero">
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-field">
                    <label>Cancella risultato precedente</label>
                    <input type=checkbox name="search-reset" checked>
                  </div>
                </div>
              </div>
            </div>
            <div class="tool-panel-buttons">
              <button type="button" @click=${this.doSearch}>Cerca</button>
              <button type="button" @click=${this.doSearchClean}>Pulisci</button>
            </div>
          </div>
        </k-overlay>
    `
  }

  renderPanelMeasure() {
    let overlayRef:KelydraOverlay;

    return html`
        <k-overlay id="panel-measure" class="tool-overlay" anchor="window" moveable="moveable"  autoclose="none" @hide=${()=> {this.onPanelClose('measure')}} ${ref((value:any) => {overlayRef = value})} 
                    position="custom" initialLeft="80px" initialTop="160px">
          <div class="tool-panel">
            <div class="tool-panel-title">
              <div class="tool-panel-title-icon"><img src="resources/image/measure.png"></div>
              <div class="tool-panel-title-caption">Misura</div>
              <div class="tool-panel-title-close"><img src="resources/svg/close.svg" @click=${() => overlayRef.hide()}></div>
            </div>
            <div class="tool-panel-content">
              <table>
                <tr>
                  <td class="label">Lunghezza</td>
                  <td id="measure-dialog-length-a" class="value"></td>
                  <td id="measure-dialog-length-b" class="value"></td>
                </tr>
                <tr>
                  <td class="label">Perimetro</td>
                  <td id="measure-dialog-perimeter-a" class="value"></td>
                  <td id="measure-dialog-perimeter-b" class="value"></td>
                </tr>
                <tr>
                  <td class="label">Area</td>
                  <td id="measure-dialog-area-a" class="value"></td>
                  <td id="measure-dialog-area-b"  class="value"></td>
                </tr>
              </table>
            </div>
          </div>
        </k-overlay>
    `
  }


  renderPanelPrint() {
    let overlayRef:KelydraOverlay;

    return html`
        <k-overlay id="panel-print" class="tool-overlay" anchor="window" moveable="moveable"  autoclose="none" ${ref((value:any) => {overlayRef = value})} 
        position="custom" initialLeft="100px" initialTop="200px">
          <div class="tool-panel">
            <div class="tool-panel-title">
              <div class="tool-panel-title-icon"><img src="resources/image/print.png"></div>
              <div class="tool-panel-title-caption">Esporta</div>
              <div class="tool-panel-title-close"><img src="resources/svg/close.svg" @click=${() => overlayRef.hide()}></div>
            </div>
            <div class="tool-panel-content">
              <div class="form-form">
                <div class="form-row">
                  <div class="form-field">
                    <label>Titolo</label>
                    <input name="print-title" value=${this.context?.caption}>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-field">
                    <label>Sottotitolo</label>
                    <input name="print-subtitle">
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-field">
                    <label>Scala</label>
                    <input name="print-scale" list="scale-values">
                    <datalist id="scale-values">
                      <option>100000</option>
                      <option>50000</option>
                      <option>25000</option>
                      <option>10000</option>
                      <option>5000</option>
                      <option>2000</option>
                      <option>1000</option>
                    </datalist>
                  </div>
                  <div class="form-field">
                    <label>Formato</label>
                    <select name="print-format">
                      <option value="pdf">PDF</option>
                      <option value="jpg">Immagine jpg</option>
                    </select>
                  </div>
                  <div class="form-row">
                    <div class="form-field">
                      <label>Visualizza selezione</label>
                      <input type=checkbox name="print-selection" checked>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="tool-panel-buttons">
              <button type="button" @click=${this.doPrint}>Esporta</button>
              <button type="button" @click=${() => overlayRef.hide()}>Annulla</button>
            </div>
          </div>
        </k-overlay>
    `
  }

  renderPanelDocumentLink() {
    if (!this.context) {
      return;
    }

    let overlayRef:KelydraOverlay;

    return html`
        <k-overlay id="panel-document-link" class="tool-overlay" anchor="window" animated="opacity" autoclose="none" moveable="moveable" resizable="resizable" initialWidth="800" initialHeight="600" ${ref((value:any) => {overlayRef = value})}>
          <div class="tool-panel">
            <div class="tool-panel-title">
              <div class="tool-panel-title-icon"><img src="resources/image/docs.png"></div>
              <div class="tool-panel-title-caption">Documenti</div>
              <div class="tool-panel-title-close"><img src="resources/svg/close.svg" @click=${() => overlayRef.hide()}></div>
            </div>
            <div class="tool-panel-content">
              <iframe src=${this.context.ntaReference}></iframe>
            </div>
          </div>            
        </k-overlay>  
   `
  }

  renderPanelDocumentTree() {
    if (!this.context) {
      return;
    }

    let overlayRef:KelydraOverlay;

    const path:ITreeItem[] = [];

    if (this.documentDataEntity) {
      let doc = this.treeLookup[this.documentDataEntity.UUID];
      while (doc != null) {
        path.unshift(doc);
        doc = doc.parent;
      }
    }

    let renderPath = (path:ITreeItem[]):any => {
      if (path && path.length) {
        return html`
          <div class="articolo-path">
            <div class="articolo-caption">${path[0].caption}</div>
            ${renderPath(path.slice(1))}
          </div>
        `
      }
    }


    return html`
        <k-overlay id="panel-document-tree" class="tool-overlay" anchor="window" animated="opacity" autoclose="none" moveable="moveable" resizable="resizable" initialWidth="800px" initialHeight="600px" ${ref((value:any) => {overlayRef = value})}>
          <div class="tool-panel">
            <div class="tool-panel-title">
              <div class="tool-panel-title-icon"><img src="resources/image/docs.png"></div>
              <div class="tool-panel-title-caption">Documenti</div>
              <div class="tool-panel-title-close"><img src="resources/svg/close.svg" @click=${() => overlayRef.hide()}></div>
            </div>
            <div class="tool-panel-toolbar border">
              
            </div>
            <div class="tool-panel-content">
              <k-splitter orientation="horizontal"  sizes="240px,*">
                <div slot="0" class="tree">
                  <div class="tree-tools">
                    <button type="button" class=${classMap({selected:this.documentsShow == 'all'})}  @click=${() => this.documentsShow = 'all'}>Tutte</button> 
                    <button type="button" class=${classMap({selected:this.documentsShow == 'selected'})}  @click=${() => this.documentsShow = 'selected'}>Selezionate</button>
                  </div>
                  <div class="tree-container border">
                    <div class="documents-all ${classMap({selected:this.documentsShow == 'all'})}" >
                      <k-tree .rootItem=${this.tree} 
                          @tree-select-item=${(e:any) => this.onNormeTreeSelect(e)} 
                          ?readonly=${true}
                        ></k-tree>
                    </div>
                    <div class="documents-selected ${classMap({selected:this.documentsShow == 'selected'})}">
                      ${this.selection.map(item => html`
                          <div class="document-selected ${classMap({selected:item == this.selectionSelected})}" @click=${() => this.onSelectionSelect(item)}>${item.caption}</div>
                        `)}
                    </div>
                  </div>
                </div>
                <div slot="1" class="articolo">
                  <div class="articolo-paths border">
                    ${renderPath(path)}
                  </div>
                  <div class="articolo-content border">${unsafeHTML(this.documentDataEntity?.DC_CONTENT)}</div>
                </div>
              </k-splitter>
            </div>
          </div>            
        </k-overlay>  
   `

  }


  renderPanelHelp() {
    if (!this.context) {
      return;
    }

    let overlayRef:KelydraOverlay;

    let decorateRef = (element:Element) =>  {
      let htmlElement = <HTMLElement> element;
      let propertyName = htmlElement?.dataset.property;
      if (propertyName && this.parameters[propertyName]) {
        let value = this.parameters[propertyName];
        htmlElement.innerHTML = value;
      }
    }
    

    return html`
        <k-overlay id="panel-help" class="tool-overlay" anchor="window" animated="opacity" autoclose="none" backdrop="backdrop" ${ref((value:any) => {overlayRef = value})}>
          <div class="tool-panel">
            <div class="tool-panel-title">
              <div class="tool-panel-title-icon"><img src="resources/image/help.png"></div>
              <div class="tool-panel-title-caption">Informazioni</div>
              <div class="tool-panel-title-close"><img src="resources/svg/close.svg" @click=${() => overlayRef.hide()}></div>
            </div>
            <div class="tool-panel-content">
              <div class="panel-info">
                <div class="panel-info-main">
                  <div class="panel-info-logo">
                    <img src="../../../SilverBrowser/ui/resources/logo512.png">
                  </div>
                  <div class="panel-info-title">
                    <div class="panel-info-customer">${this.context?.caption}</div>
                    <div class="panel-info-product-title" data-property="Title" ${ref(decorateRef)}>P.R.G. on line</div>
                    <div class="panel-info-product-sub" data-property="Subtitle" ${ref(decorateRef)}></div>
                  </div>
                </div>
                <div class="panel-info-sub">
                  <div class="panel-info-distributor">
                    <a href="http://www.geoservice.com" target="engine">
                      <img src="resources/info/distributor.png">
                    </a>
                  </div>
                  <div class="panel-info-version">
                    <div>Versione <b>${SilverPrgApplication.Version}</b></div>
                    <div>Build: <b>${SilverPrgApplication.Build}</b></div>
                  </div>
                  <div class="panel-info-engine">
                    <a href="http://www.silverbrowser.info" target="engine">
                      <img src="resources/engine-name.png">
                      <div>Engine</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </k-overlay>
    `
  }





  render() {
    return html`
      <div class="k-desktop-app">
        <silver-map @mapReady=${() => this.onMapReady()}></silver-map>
        <silver-tools caption="${this.context?.caption}" @tool=${(e:any) => this.doSelectTool(e)}></silver-tools>
        ${this.renderPanelDocumentLink()}
        ${this.renderPanelDocumentTree()}
        ${this.renderPanelLegend()}
        ${this.renderPanelSearch()}
        ${this.renderPanelMeasure()}
        ${this.renderPanelPrint()}
        ${this.renderPanelHelp()}
      </div>

      <div id="wait" class="wait-overlay hidden">
        <div class="wait-overlay__wrapper">
            <div class="wait-overlay__spinner">
                <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
            </div>
        </div>
      </div>
    `
  }



}

export class UserInterface implements IUserInterface {

  constructor(protected readyPromise:Promise<any>, protected application:SilverPrgApplication) {
  }

  get ready(): Promise<any> {
    return this.readyPromise;
  }

  showWait() {
    this.application.showWait();
  }

  hideWait() {
    this.application.hideWait();
  }


  async alert(params: IAlertOptions): Promise<string> {
    return "OK";
  }


}


export interface IAppContext {
  caption:string;
  parameters:IParameter[];
  servicesInfo:ICartoServiceInfo[];
  sezioni:string[];
  ntaReference:string;
  ntaReferenceType: 'download' | 'link' | 'popup' | 'tree';
}

export interface ICartoServiceInfo {
  name: string;
  type: string;
  caption: string;
  url: string;
  visible: boolean;
  alpha: number;
}

export interface ICartoSearchResult {
  entityId:string;
  wkt:string;
}

export interface ICartoExportResult {
  url:string;
}

interface INormaTreeData {
  TR_NAME:string;
  TR_CAPTION:string;
  TR_TREE:string;
}

interface INormaData {
  UUID:string;
  DC_CODE:string;
  TR_NAME:string;
  DC_TITLE:string;
  DC_CONTENT:string;
}

interface IJsonTree {
  uuid:string;
  caption:string;
  children:IJsonTree[];
}

export interface IDataEntityResult {
  entity:any;
  confirm:IConfirm;
}

export interface IConfirm {
  type: 'info' | 'warn' | 'error';
  message:string;
  confirmCaption:string;
  cancelCaption:string;
}


